export const ownedByAsaren = true;
export const headerTitle = 'Master Data 360';
